import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { PageTitle } from '../../../_metronic/layout/core';
import { 
  MixedWidget12,
  WelcomeWidgetDashboard,
  BloodPressureDashboard,
  WeightDashboard,
  MixedWidget10,
  MixedWidget11,
  DashboardLauncher,

 } from '../../../_metronic/partials/widgets';

interface User {
  firstName: string;
}

const DashboardPage = () => {
  const [user, setUser] = useState<User | null>(null);
  const [greeting, setGreeting] = useState('');
  const [currentDateTime, setCurrentDateTime] = useState('');

  useEffect(() => {
    const fetchData = () => {
      // Retrieve the user data from local storage
      const userData = localStorage.getItem('user');
      if (userData) {
        const parsedUser = JSON.parse(userData);
        setUser(parsedUser);
      }
    };
  
    // Delay the execution of fetchData by 500 milliseconds
    const delay = 500; // Adjust the delay as needed
    const timeoutId = setTimeout(fetchData, delay);
  
    // Clean up the timeout when the component is unmounted
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    // Get the current hour
    const currentHour = new Date().getHours();

    // Set the greeting based on the current hour
    if (currentHour < 12) {
      setGreeting('Good Morning');
    } else if (currentHour < 18) {
      setGreeting('Good Afternoon');
    } else {
      setGreeting('Good Evening');
    }

    // Update the current date and time every second
    const interval = setInterval(() => {
      const currentDate = new Date().toLocaleDateString();
      const currentTime = new Date().toLocaleTimeString();
      setCurrentDateTime(`${currentDate} ${currentTime}`);
    }, 1000);

    // Clean up the interval when the component is unmounted
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <>
     {/* begin::Row */}
     <div className='row g-5'>
  {/* <div className='card-xxl-stretch-100'>
    <WelcomeWidgetDashboard
      className='card-xxl-stretch-100 mb-5 mb-xl-12'
      svgIcon='/media/icons/duotune/general/gen030.svg'
      color='primary'
      iconColor='white'
      title={user?.firstName ? `${greeting}, ${user.firstName}` : 'Loading...'}
      description={currentDateTime ? `${currentDateTime}` : 'Loading...'}
      titleColor='white'
      descriptionColor='white'
    />
  </div> */}
  
</div>

 {/* begin::Row */}
 {/* <div className='row g-5' style={{marginTop: '1px'}}> 
    <div className='col-xxl-12'>
        <WelcomeWidgetDashboard
       className='card-xxl-stretch-100 mb-5 mb-xl-8'
        // bgColor='#009ef7'
        svgIcon='/media/icons/duotune/general/gen030.svg'
        color='primary'
        iconColor='white'
        title={user?.firstName ? `${greeting}, ${user.firstName}` : 'Loading...'}
        description={currentDateTime ? `${currentDateTime}` : 'Loading...'}
        titleColor='white'
        descriptionColor='white'
        />
      </div>
    </div> */}

    
 {/* begin::Row */}
 {/* <div className='row g-5'>
    <div className= 'card-xxl-stretch-100'>
        <DashboardLauncher 
        className='card-xxl-stretch-100 mb-5 mb-xl-8'
       chartColor='#FF8E9D'
        chartHeight='175px'
        strokeColor='danger'
        
        />
      </div>
    </div> */}


{/* <div className='row g-5'>
  <div className='col-xl-12 '>
    <BloodPressureDashboard
      className='card-xxl-stretch-100 mb-5 mb-xl-8'
      chartColor='primary'
      chartHeight='175px'
    />
  </div>
</div> */}

{/* Row with custom margin */}
{/* <div className='row g-5'>
  <div className='col-xl-12'>
    <WeightDashboard
      className='card-xxl-stretch-100 mb-5 mb-xl-8'
      chartColor='primary'
      chartHeight='200px'
    />
  </div> */}
  {/* <div className='col-xl-6'>
    <MixedWidget12
      className='card-xxl-stretch-100 mb-5 mb-xl-8'
      chartColor='danger'
      chartHeight='200px'
    />
  </div> */}
{/* </div> */}

 {/* begin::Row */}
    {/* <div className='row gy-5'>
      
      <div className='col-xxl-4'>
        <ListsWidget5 className='card-xxl-stretch' />
      </div>
      <div className='col-xxl-4'>
        <MixedWidget10
          className='card-xxl-stretch-50 mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='150px'
        />
        <MixedWidget11
          className='card-xxl-stretch-50 mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='175px'
        />
      </div>
    </div> */}

{/* Row with custom margin */}
{/* <div className='row g-5 row-with-margin'>
  <div className='col-xl-12'>
    <WelcomeWidgetDashboard
      className='card-xl-stretch mb-5 mb-xl-8'
      svgIcon='/media/icons/duotune/general/gen013.svg'
      color='dark'
      iconColor='gray-100'
      title='Upcoming Tests'
      description='View upcoming health checks'
      titleColor='gray-100'
      descriptionColor='gray-100'
    />
  </div>
</div> */}

{/* begin::Row */}
{/* <div className='row gy-5 g-xl-8'>
  <div className='col-xxl-4'>
   
  </div>
</div> */}
{/* end::Row */}

{/* begin::Row */}
{/* <div className='row gy-5 g-xl-8'>
  <div className='col-xxl-4'>
    
  </div>
</div> */}
{/* end::Row */}

{/* begin::Row */}
{/* <div className='row gy-5 g-xl-8'>
  <div className='col-xxl-4'>
    
  </div>
</div> */}
{/* end::Row */}

    
</>
  );
};

const AdminDashboard = () => {
  const intl = useIntl();
  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'MENU.DASHBOARD' })}
      </PageTitle>
      <DashboardPage />
    </>
  );
};

export { AdminDashboard };
